import DashboardPage from "components/dashboard/DashboardPage.component"

const Dashboard = () => {
  return (
    <DashboardPage />
  )
}

export default Dashboard
